import { AirconSearchProduct, HESLP_AIRCON_SEARCH_PRODUCT } from './aircon-reference-data.model';

/** CER register of air-source heat pump water heaters: the listing an IPART product was joined to (ESC-117). */
export interface HeatPumpCerListing {
    brand: string;
    model: string;
    eligibleFrom: string | null;
    eligibleTo: string | null;
    zone1Certificates: number | null;
    zone2Certificates: number | null;
    zone3Certificates: number | null;
    zone4Certificates: number | null;
    zone5Certificates: number | null;
}

/**
 * One HESLP-eligible heat pump water heater from the QuoteService `reference-data/heat-pumps` search (ESC-117):
 * the IPART accepted product joined to its CER register entry, one result per brand/model. Unlike aircon there is
 * no single registry id; `acceptedProductIds` carries every IPART id the brand/model is listed under.
 */
export interface HeatPumpReferenceData {
    brand: string;
    modelNumber: string;
    acceptedProductIds: string[];
    productType: string;
    systemType: string | null;
    refrigerant: string | null;
    refrigerantGwp: number | null;
    tankSizeL: number | null;
    totalSystemTankVolumeL: number | null;
    heatPumpUnitModelNumbers: string | null;
    effectiveFrom: string | null;
    effectiveTo: string | null;
    cer: HeatPumpCerListing | null;
    matchTier: string;
}

export interface HeatPumpSearchResponse {
    results: HeatPumpReferenceData[];
    totalMatches: number;
}

/** The heat pump search is HESLP-only: QuoteService rejects any other (or a missing) product. */
export type HeatPumpSearchProduct = AirconSearchProduct;
export const HESLP_HEAT_PUMP_SEARCH_PRODUCT: HeatPumpSearchProduct = HESLP_AIRCON_SEARCH_PRODUCT;
